import { createSlice } from '@reduxjs/toolkit';
import { IInitialSitemapState } from './types';

const SLICE_NAME = 'SITES_MAP_SLICE';

export const initialState: IInitialSitemapState = {
  loading: false,
  error: '',
  data: [],
  createLoading: false,
  createError: '',
  createSuccess: false,
  deleteLoading: false,
  deleteError: '',
  deleteSuccess: false,
  updateLoading: false,
  updateError: '',
  updateSuccess: false,
  reorderSiteMapLoading: false,
  reorderSiteMapError: '',
  reorderSiteMapSuccess: false,

  sitemapUrlsAddLoading: false,
  sitemapUrlsAddError: '',
  sitemapUrlsAddSuccess: false,

  currentSitemapSiteCreating : null,

  updateSiteMapFromUrlLoading: false,
  updateSiteMapFromUrlError: '',
  updateSiteMapFromUrlSuccess: false,

  DeleteAllSitemapLoading: false,
  DeleteAllSitemapError: null,
  DeleteAllSitemapSuccess: false,


};

const siteMapSlice = createSlice({
  name: SLICE_NAME,
  initialState: initialState,
  reducers: {
    fetchSiteMapError: (state, { payload } ) => {
      state.loading = false;
      state.error = payload;
      state.data = initialState.data;
    },
    fetchSiteMap: (state,{ payload }) => {
      state.loading = true;
      state.error = '';
    },
    fetchSiteMapSuccess: (state, { payload }) => {
 
      
      state.loading = false;
      // const existingData = Array.isArray(state.data) ? state.data : [];
      // Ensure payload is an array
      // const newData = Array.isArray(payload) ? payload : [payload];
      // Append the new data
      state.data =  payload;
    },

    fetchSiteMapCreating: (state, { payload } ) => {
      state.createLoading = true;

      if (!Array.isArray(state.currentSitemapSiteCreating)) {
        state.currentSitemapSiteCreating = [];
      }
      const exists = state.currentSitemapSiteCreating.find(item => item === payload);

      // Only push payload if it doesn't already exist in the array
      if (!exists) {
        state.currentSitemapSiteCreating.push(payload);
      }

      // state.currentSitemapSiteCreating = payload
    },

    fetchSiteMapEndCreating: (state, { payload } ) => {
      state.createLoading = false;
      state.currentSitemapSiteCreating = null;
    },

    createSiteMapError: (state, { payload } ) => {
      state.createLoading = false;
      state.createError = payload;
      state.createSuccess = initialState.data;
      state.currentSitemapSiteCreating = null;
      
    },
    createSiteMap: (state,{ payload }) => {
      
      state.createLoading = true;
      state.createError = '';


      if (!Array.isArray(state.currentSitemapSiteCreating)) {
        state.currentSitemapSiteCreating = [];
      }

      const exists = state.currentSitemapSiteCreating.find(item => item === payload.siteUUID);

      if (!exists) {
        state.currentSitemapSiteCreating.push(payload.siteUUID);
      }

    },
    createSiteMapSuccess: (state, { payload }) => {
      state.createLoading = false;
      state.createSuccess = true;

      // const existingData = Array.isArray(state.data) ? state.data : [];
      // // Ensure payload is an array
      // const newData = Array.isArray(payload) ? payload : [payload];
      // Append the new data
      state.data =  payload;
      // state.data = payload;
      state.currentSitemapSiteCreating = null;
    },

    deleteSiteMapError: (state, { payload } ) => {
      state.deleteLoading = false;
      state.deleteError = payload;
      state.deleteSuccess = initialState.data;
    },
    deleteSiteMap: (state,{ payload }) => {
      state.deleteLoading = true;
      state.deleteError = '';
    },
    deleteSiteMapSuccess: (state) => {
      state.deleteLoading = false;
      state.deleteSuccess = true;
    },
    updateSiteMapError: (state, { payload } ) => {
      state.updateLoading = false;
      state.updateError = payload;
      state.updateSuccess = initialState.data;
    },
    updateSiteMap: (state,{ payload }) => {
      state.updateLoading = true;
      state.updateError = '';
      
    },
    updateSiteMapSuccess: (state) => {
      state.updateLoading = false;
      state.updateSuccess = true;
    },
    siteMapinit: (state) => {
      state.updateSuccess = false;
      state.deleteSuccess = false;
      state.reorderSiteMapSuccess= false;
      state.sitemapUrlsAddSuccess = false;
    },

    reorderSiteMap: (state,{ payload }) => {
      state.reorderSiteMapLoading = true;
      state.reorderSiteMapError = '';
      
    },
    reorderSiteMapSuccess: (state,{ payload }) => {
      state.reorderSiteMapLoading = false;
      state.reorderSiteMapSuccess = payload;
    },
    reorderSiteMapError: (state) => {
      state.reorderSiteMapLoading = false;
      state.reorderSiteMapError = 'error';
      state.reorderSiteMapSuccess = false;
    },


    sitemapUrlsAdd: (state,{ payload }) => {
      state.sitemapUrlsAddLoading = true;
      state.sitemapUrlsAddError = '';
    },
    sitemapUrlsAddSuccess: (state,{ payload }) => {
      state.sitemapUrlsAddLoading = false;
      state.sitemapUrlsAddSuccess = payload; 
    },
    sitemapUrlsAddError: (state) => {
      state.sitemapUrlsAddLoading = false;
      state.sitemapUrlsAddError = 'error';
      state.sitemapUrlsAddSuccess = false;
    },

    updateSiteMapFromUrl: (state,{ payload }) => {
      state.updateSiteMapFromUrlLoading = true;
      state.updateSiteMapFromUrlError = '';
    },
    updateSiteMapFromUrlSuccess: (state,{ payload }) => {
      state.updateSiteMapFromUrlLoading = false;
      state.updateSiteMapFromUrlSuccess = payload; 
    },
    updateSiteMapFromUrlError: (state) => {
      state.updateSiteMapFromUrlLoading = false;
      state.updateSiteMapFromUrlError = 'error';
      state.updateSiteMapFromUrlSuccess = false;
    },

    DeleteAllSitemap: (state,{ payload }) => {
      state.DeleteAllSitemapLoading = true;
      state.DeleteAllSitemapError = '';
    },
    DeleteAllSitemapSuccess: (state,{ payload }) => {
      state.DeleteAllSitemapLoading = false;
      state.DeleteAllSitemapSuccess = payload; 
    },
    DeleteAllSitemapError: (state) => {
      state.DeleteAllSitemapLoading = false;
      state.DeleteAllSitemapError = 'error';
      state.DeleteAllSitemapSuccess = false;
    },

  },
  
});

export default siteMapSlice;
